import { isSameDay, parseISO, startOfDay } from "../../date-fns-local";

export const dateFilterParams =
{
  suppressAndOrCondition: true,
  comparator: function (filterLocalDateAtMidnight: Date, dateAsString: string) {
    if (dateAsString == null) {
      return -1;
    }

    var date = startOfDay(parseISO(dateAsString));
    if (date < filterLocalDateAtMidnight) {
      return -1;
    } else if (date > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  browserDatePicker: true
};

